import React from 'react';

const SingleScoreItem = ({ img, ...props }) => {
	const score = props?.score ?? `+1`;
	const icon = props?.icon ?? false;

	return (
		<>
			<span class="points">{score}</span>

			<span class="img">
				<span class="img_c">
					<img src={img.full_image} width="100%" alt={img.name} />
				</span>

				{(icon !== false) && (
					<span class={`status_icon ${icon}`} />
				)}
			</span>
		</>
	)
};

const GameScoredInstructions = ({ stage, ...props }) => {
	const ok_images = props?.ok_images ?? [];
	const ko_images = props?.ko_images ?? [];
	const score_ranges = props?.score_ranges ?? {};
	const max_items_per_row = props?.max_items_per_row ?? 4;

	const one_lined = (ko_images.length > 0 && (ok_images.length + ko_images.length) <= max_items_per_row) ? true : false;

	return (
		<div class="score_info">
			<ul class="items">
				{ok_images.map((img, i) => {
					return (
						<li key={`ok_${i}`} class="is_ok">
							<SingleScoreItem
								img={img}
								{...score_ranges[ok_images[i].type]}
							/>
						</li>
					)
				})}

				{one_lined === true && ko_images.map((img, i) => {
					return (
						<li key={`ko${i}`} class="is_ko">
							<SingleScoreItem
								img={img}
								{...score_ranges[ko_images[i].type]}
							/>
						</li>
					)
				})}
			</ul>

			{(one_lined === false && ko_images.length > 0) && (
				<ul class="items">
					{ko_images.map((img, i) => {
						return (
							<li key={`ko${i}`} class="is_ko">
								<SingleScoreItem
									img={img}
									{...score_ranges[ko_images[i].type]}
								/>
							</li>
						)
					})}
				</ul>
			)}
		</div>
	)
};

export default GameScoredInstructions;